module.exports = __webpack_public_path__ + "img/huiyuanka.cede1270.png";